var formID = "form_manual";
var prescriptionId = "";
document.addEventListener('DOMContentLoaded', function() {
  var tabs = document.querySelectorAll('#material-tabs a');
  
  if (tabs.length > 0) {
    var $active = tabs[0];
    $active.classList.add('active');
    
    var $content = document.querySelector($active.hash);
    
    Array.prototype.forEach.call(tabs, function(link) {
      if (link !== $active) {
        document.querySelector(link.hash).style.display = 'none';
      }
    });
    
    document.getElementById('material-tabs').addEventListener('click', function(e) {
      var target = e.target;

      if (target.tagName === 'A') {
        var selectedTabForm = target.getAttribute('data-form');
        // var inactiveTabForm = $active.getAttribute('data-form');
        changeSelectedForm(selectedTabForm);
        
        $active.classList.remove('active');
        $content.style.display = 'none';
        
        $active = target;
        $content = document.querySelector(target.hash);
        
        $active.classList.add('active');
        $content.style.display = 'block';
        
        e.preventDefault();
      }
    });

    changeSelectedForm('form_manual');
    clearForm();
    var formButton = document.getElementById("clsg-prescription-submit");
    formButton.addEventListener("click", function() {
           formSubmit();
    });


  }
});

function changeSelectedForm(selectedTabForm){
  console.log(selectedTabForm);
  formID = selectedTabForm;
  clearForm();
}

// function addFormSubmitEvent(selectedTabForm, formButton){
//    formButton.addEventListener("click", function() {
//        formSubmit(selectedTabForm);
//    });
//    console.log('Added Form Event!');
// }
// function removeFormSubmitEvent(inactiveForm, formButton){
//   formButton.removeEventListener("click", function() {
//       formSubmit(inactiveForm);
//   });
//   console.log('Removed Form Event!');
// }


function formSubmit(){
  // console.log('check if submit is running');

  if (formID) {
    if(formID == 'form_dropzone'){
      var form = document.getElementById(formID);
      var formData = new FormData(form);
      formData.append("file", dropzone_file);
      if(prescriptionId){
        formData.append("id", prescriptionId);
      }
      // console.log(form.action);
      updateStatus(dropzoneStatus, uploadingStatus, uploadingStatusColor, '');
      fetch(form.action, {
        method: "POST",
        body: formData,
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
      .then(response => response.text())
      .then(responseText => {
        if(!responseText.includes("Error")){
          updateStatus(dropzoneStatus, completedStatus, completedStatusColor, '');
          clearForm();
          // afterPrescriptionSuccess();
          delayClosePrescriptionModal(3000);
        } else {
          updateStatus(dropzoneStatus, errorStatus, errorStatusColor, '');
        }

      })
      .catch(error => console.error("Error:", error));
    } else {
      console.log(formID);
      var form = document.getElementById(formID);
      var formData = new FormData(form);
      let cartToken = document.getElementById('cart_token').value;
      formData.append("cartToken", cartToken);
      if(prescriptionId){
        formData.append("id", prescriptionId);
      }
      updateStatus(manualStatus, uploadingStatus, uploadingStatusColor, '');
      fetch(form.action, {
        method: "POST",
        body: formData,
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
      .then(response => response.text()) 
      .then(responseText => {
        if(!responseText.includes("Error")){
          console.log(responseText);
          updateStatus(manualStatus, completedStatus, completedStatusColor, '');
          clearForm();
          // afterPrescriptionSuccess();
          delayClosePrescriptionModal(1000);
        } else {
          updateStatus(manualStatus, errorStatus, errorStatusColor, '');

        }
        
        
      })
      .catch(error => console.error("Error:", error));
    }
  }
}

function delayClosePrescriptionModal(delaySec){
  setTimeout(() => {
    toggleModal();
  }, delaySec);
}

function updateStatus(divElement, divContent, divColor, textColor){
  if(divElement){
    divElement.innerHTML = divContent;
    divElement.style.visibility = 'visible';
    if(divColor){
      divElement.style.backgroundColor = divColor;
    }
    if(textColor){
      divElement.style.color = textColor;
    }
  }
}


function clearForm(){
  if(formID){
    var form = document.getElementById(formID);
    form.reset();
    dropzoneReset();
  }
}

function hide(divElement){
  divElement.style.visibility = 'hidden';
}

function dropzoneReset(){
  document.getElementById('dropzone-btn-upload').innerHTML = 'Upload';
  fileName.classList.add("hidden");
}

function enableButton(){
  var formSubmitBtn = document.getElementById('clsg-prescription-submit');
  formSubmitBtn.disabled = false;
}

function disableButton(){
  var formSubmitBtn = document.getElementById('clsg-prescription-submit');
  formSubmitBtn.disabled = true;
}
